import { api } from './client';

export type Plan = 'TRIAL' | 'BASIC' | 'PRIMA' | 'GOLD';

export interface PlanFeatures {
  whatsappReminders: boolean;
  eInvoicing: boolean;
  eWayBill: boolean;
  gstr2aApiSync: boolean;
  manufacturingModule: boolean;
  bankReconciliation: boolean;
  balanceSheet: boolean;
  prioritySupport: boolean;
  dataMigration: 'none' | 'one_time' | 'unlimited';
  reportsAccess: 'view_only' | 'partial' | 'full' | 'full_plus';
  cloudSync: boolean;
  stockReport: boolean;
  profitLoss: boolean;
  creditDebitNotes: boolean;
}

export interface PlanLimits {
  invoicesPerMonth: number | null;
  invoiceTypesAllowed: string[];
  usersMax: number;
  templatesAllowed: string[];
}

export interface Subscription {
  plan: Plan;
  planName: string;
  price: { firstYear: number; renewal: number };
  activatedAt: string | null;
  expiresAt: string | null;
  isExpired: boolean;
  trialDaysLeft: number | null;
  limits: PlanLimits;
  features: PlanFeatures;
  usage: { invoices: number; users: number };
  withinLimits: { invoices: boolean; users: boolean };
}

export const subscriptionApi = {
  get: () => api.get<Subscription>('/subscription'),
  update: (plan: Plan, durationDays?: number) =>
    api.put<Subscription>('/subscription', { plan, durationDays }),
  requestUpgrade: () => api.post<{ sent: true }>('/subscription/upgrade-request', {}),
};
